import { numberField, objectField, stringField } from "./parseFields";
import type { ComplianceManifestJob } from "./types";

export function parseComplianceManifestJob(
  payload: unknown,
): ComplianceManifestJob | null {
  if (payload == null || typeof payload !== "object") {
    return null;
  }
  const record = payload as Record<string, unknown>;
  const nested = objectField(record, "data") ?? record;
  const requestId = stringField(nested, "request_id", "requestId", "id");
  if (!requestId) {
    return null;
  }
  return {
    requestId,
    dispatched: numberField(nested, "dispatched"),
  };
}
